import React, { useContext, useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../i18n';
import { Locale } from '@microsoft/iot-cardboard-js';
import { LanguageStorageKey } from '../Constants/Constants';
import { LanguageContextType } from '../Constants/Types';

const LanguageContext = React.createContext<LanguageContextType>({
    selectedLang: Locale.EN,
    setSelectedLang: (value: Locale) => {}
});
export const useLanguageContext = () => useContext(LanguageContext);

export const I18nProviderWrapper: React.FC<{}> = ({ children }) => {
    const [language, setLanguage] = useState<Locale>(
        (localStorage.getItem(LanguageStorageKey) as Locale) || Locale.EN
    );

    useEffect(() => {
        i18n.changeLanguage(language);
    }, [language]);

    return (
        <LanguageContext.Provider
            value={{ selectedLang: language, setSelectedLang: setLanguage }}
        >
            <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
        </LanguageContext.Provider>
    );
};
